<!--其它出库  -->
<template>
<div>
	<div class="info-box">
		<el-dialog title="订单信息" v-if="dialogVisible" :visible.sync="dialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :modal-append-to-body="false" width="1000px" :before-close="cancle"
			top="3vh">
			<div>
						<div class="info-title">基本信息:</div>
						<!--  -->
						<div class="mt5">
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> 单号: </span>
									<span class="ml15"> {{rowData.orderNo||'无'}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> 时间: </span>
									<span class="ml15">{{dateTimeFormat(rowData.createdTime)||'无'}}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> 客商名称: </span>
									<span class="ml15"> {{rowData.agentName||'无'}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> 客商SAP编号: </span>
									<span class="ml15">{{rowData.sapAgentNo||'无'}}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> 金额: </span>
									<span class="ml15"> {{rowData.orderMoney||'无'}}</span>
								</div>
								<div class="flex-1 flex">
									<span class="info-name"> 回单编号: </span>
									<div class="ml23">
										<span class=" agentVoucher-text"> {{rowData.agentVoucher||'无'}}</span>
										<i class="el-icon-edit-outline" title="补录回单" @click="agentVoucherEdit"></i>
									</div>

								</div>
							</div>
							<!--  -->
								<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> 付款方式:</span>
									<span  class="ml15" v-if="rowData.payType==0">现金</span>
									<span  class="ml15" v-if="rowData.payType==1">电子</span>
									<span  class="ml15" v-if="rowData.payType==2">账期</span>
									<span  class="ml15" v-if="rowData.payType==3">预付款</span>
									<span  class="ml15" v-if="rowData.payType==9">自贩</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> 支付状态: </span>
									<span  class="ml15" v-if="rowData.payStatus==0">未支付</span>
									<span  class="ml15" v-else-if="rowData.payStatus==1">已支付</span>
									<span  class="ml15" v-else-if="rowData.payStatus==2">已确认</span>
									<span  class="ml15" v-else-if="rowData.payStatus==3">支付中</span>
									<!-- <span  class="ml15" v-else>账期/预付款已确认</span> -->
								</div>
							</div>
							<!--  -->
								<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> 巡回计划: </span>
									<span class="ml15"> {{rowData.planCode||'无'}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> 路线: </span>
									<span class="ml15">{{rowData.routeName||'无'}}</span>
								</div>
							</div>
							<!--  -->
								<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> SAP开票单位名称: </span>
									<span class="ml15"> {{rowData.ncDrawerName||'无'}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> 是否预付款: </span>
									<span class="ml15">{{rowData.advancesFlag||'无'}}</span>
								</div>
							</div>
							<!--  -->
								<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> SAP同步状态: </span>
									<span class="ml15"> {{rowData.ncSynbackinfo||'无'}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> 制单人: </span>
									<span class="ml15">{{rowData.createdName||'无'}}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
						</div>

					</div>
				<!--  -->
					<!-- 配送客商情况 -->

				<div class="info-title mt20">订单明细:</div>
				<el-table class="mt20" :data="tableData"  ref="multipleTable"
					:header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333',height:'25px'}"
					 border style="width: 100%">
					 <el-table-column prop="skuName" label="SKU"></el-table-column>
					 <el-table-column prop="skuPrice" label="单价"></el-table-column>
					 <el-table-column prop="productQuantity" label="数量"></el-table-column>
					 <el-table-column prop="saleMoney" label="金额"></el-table-column>
					 <el-table-column prop="storeName" label="出货仓"></el-table-column>
					 <el-table-column prop="productDate" label="生产日期"></el-table-column>
				</el-table>

			<div class="info-title mt20">第三方支付信息:</div>
						<!--  -->
						<div class="mt5">
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> 线上支付单号: </span>
									<span class="ml15"> {{rowData.onlineOrderno||'无'}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> 第三方支付凭单: </span>
									<span class="ml15"> {{rowData.onlineVoucher||'无'}}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
						</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="cancle()">取 消</el-button>
			</span>
		</el-dialog>

	</div>
	<addVoucher ref="addVoucher" @getInfo="getInfo"></addVoucher>
	</div>
</template>

<script>
	import {
		debounce
	} from '@/utils/debounce'
import {dateTimeFormat} from '@/utils/common'
import addVoucher from './add-voucher.vue'
	export default {
		components: {
			addVoucher
		},
		data() {
			return {
				dialogVisible: false,
				dateTimeFormat:null,
				ruleForm:{
					orderId: "",
					groupId: "",
				},
				tableData:[],
				rowData:{},
			}
		},
		created() {
			this.dateTimeFormat = dateTimeFormat
		},
		methods: {
			init(data) {
				this.$nextTick(() => {
					this.dialogVisible = true
					this.rowData={}
					this.pageNo = 1
					this.ruleForm = {
						orderId: "",
						groupId: "",
					}
					if (data) {
						this.ruleForm.orderId = data.dataKey
						// this.ruleForm.groupId = data.groupId
						this.getInfo()
					}

				})


			},
			// 查询
			getInfo() {
				let that = this;
				that.$request.post(
						"orderInfo",
						true, {
							orderId: that.ruleForm.orderId,
							// groupId: that.ruleForm.groupId,
						}
					)
					.then((res) => {
						if (res) {
							that.tableData = res.data.orderDetails
							that.rowData = res.data
						}
					})
			},
			// 店铺回单编辑
			agentVoucherEdit(){
				this.$refs.addVoucher.init(this.ruleForm.orderId,this.rowData.agentVoucher)
			},
			// 取消
			cancle() {
				this.dialogVisible = false
				this.$emit("getList")
			},
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.mb0 {
		margin-bottom: 0 !important;
	}

	.w90 {
		width: 110px;
	}

	.nc-box {
		padding: 10px;
		border-bottom: 1px solid #DCDFE6;
		color: #606266;
		font-size: 13px;
	}

	.mb10 {
		margin-bottom: 10px !important;
	}

	.w190 {
		width: 280px !important;
	}

	.info-box {
		/deep/ .el-dialog__body {
			// height: 420px;
			overflow-y: auto;
			padding: 20px 20px 10px;
		}
	}

	.info-title {
		background: #E5E5E5;
		color: #333;
		padding: 10px;
		box-sizing: border-box;
		font-size: 16px;
		font-weight: bold;

		img {
			vertical-align: bottom;
			display: block;
		}
	}

	.el-form-item {
		width: 420px;
	}

	.w330 {
		width: 330px;
	}

	.w420 {
		width: 420px !important;
		margin-right: 10px;
	}

	.info-name {
		display: inline-block;
		width: 140px;
		text-align: right;
	}

	.opeartion {
		font-size: 18px;
	}

	.lh30 {
		line-height: 30px;
	}

	.el-table {

		// 深度选择器，去除默认的padding
		/deep/ th {
			padding: 5px;
		}

		/deep/ td {
			padding: 5px;
		}

	}

	.nc-box {
		padding: 10px;
		border-bottom: 1px solid #DCDFE6;
		color: #606266;
		font-size: 13px;
	}
	.info-name {
		display: inline-block;
		width: 140px;
		text-align: right;
		color: #999;
	}
	.agentVoucher-text{
		min-width:160px;
		display: inline-block;

	}
	.agentVoucher-btn{
		color: #1bc9b5;
		cursor: pointer;
	}
	.el-icon-edit-outline{
		font-size: 18px;
		cursor: pointer;
	}
	.ml23{
		margin-left: 23px;
	}
</style>
